import styled from '@emotion/styled'
import { Groupbox } from 'view/components/panels'
import * as constants from 'view/styles/constants'

export const Wrapper = styled(Groupbox)`
  height: 350px;
  & label {
    flex: 0 0 50%;
  }
`

export const GridHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & label {
    font-weight: ${constants.FontWeight.SemiBold};
    color: ${constants.CORE_PRIMARY_7};
  }
`
